import { Target, Plus } from "lucide-react";
import { Button } from "../../../../../../components/UI/Button";

/**
 * Full-card empty state shown when the account has no pipeline stages yet.
 * CTA opens PipelineStagesManager modal (hosted at the layout level, handed
 * down via outlet context).
 */
const PipelineEmptyState = ({ onCreateStage }) => (
  <div className="rounded-xl border border-dashed border-gray-300 bg-white p-10 flex flex-col items-center text-center">
    <div className="w-16 h-16 rounded-2xl bg-emerald-50 text-emerald-500 flex items-center justify-center mb-4">
      <Target size={32} />
    </div>
    <h3 className="text-lg font-semibold text-gray-900">
      Chưa có giai đoạn bán hàng nào
    </h3>
    <p className="text-sm text-gray-500 mt-1.5 max-w-sm">
      Hãy tạo các giai đoạn như <em>Mới</em>, <em>Đang tư vấn</em>,{" "}
      <em>Chốt đơn</em>… để bắt đầu theo dõi pipeline bán hàng của bạn.
    </p>
    {onCreateStage && (
      <Button
        onClick={onCreateStage}
        size="sm"
        className="mt-5 h-9 px-4"
      >
        <Plus size={14} className="mr-1.5" />
        Tạo giai đoạn đầu tiên
      </Button>
    )}
  </div>
);

export default PipelineEmptyState;
